import {
  REQUEST_TOOLBAR_NOTIFICATIONS,
  REQUEST_TOOLBAR_NOTIFICATIONS_DONE,
  ToolbarNotificationsActions,
  ToolbarNotificationsState
} from "./types";

const initialState: ToolbarNotificationsState = {
  isLoading: true,
  toolbarNotifications: []
};

export function reducer(
  state = initialState,
  action: ToolbarNotificationsActions
) {
  switch (action.type) {
    case REQUEST_TOOLBAR_NOTIFICATIONS:
      return {
        isLoading: true,
        toolbarNotifications: action.payload
      };

    case REQUEST_TOOLBAR_NOTIFICATIONS_DONE: {
      return {
        isLoading: false,
        toolbarNotifications: action.payload
      };
    }
    default:
      return state;
  }
}
